import type { FunctionComponent, ReactNode } from 'react';

import utils from '../../../utils';
import type { ACCESS_LEVEL_TO_PLAN } from '../../../../shared/subscriptions';
import type { FossaFeature } from '../../settings/billing/features/consts';

import InvalidAccess from './InvalidAccess';

type Props = {
  className?: string;
  focusFeature?: FossaFeature;
  // Defaults to 'premium'.
  level?: keyof typeof ACCESS_LEVEL_TO_PLAN;
  children?: ReactNode;
  // Defaults to 'showInline'.
  behavior?: 'showInline' | 'showPage' | 'hide';
  verify?: () => boolean;
};

/**
 * Component used for restricting access to a feature or page.
 */
const AccessGate: FunctionComponent<Props> = ({
  className,
  focusFeature,
  level = 'premium',
  children,
  behavior = 'showInline',
  verify,
}) => {
  const hasAccess = verify ? verify() === true : utils.verify_subscription(level);

  //  Early return if the user has access.
  if (hasAccess) {
    return children;
  }

  //  Early return if they don't have access and the behavior is to hide.
  if (behavior === 'hide') {
    return null;
  }

  //  Otherwise, render the invalid access component.
  return (
    <div className={className}>
      <InvalidAccess
        focusFeature={focusFeature}
        accessLevel={level}
        isFullPage={behavior === 'showPage'}
      />
    </div>
  );
};

export default AccessGate;
